import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../../config.service';
import { ProductList, MasterProduct, RiskScore } from '../../../model/finzy-flex/product-list.model';
import { InvestmentPreference } from '../../../model/finzy-flex/user-attribute.model';

@Injectable()
export class ProductService {
	private readonly httpClient: HttpClient;
	private readonly configService: ConfigService;

	constructor(httpClient: HttpClient, configService: ConfigService) {
		this.httpClient = httpClient;
		this.configService = configService;
	}

	public async getSubProductsList(entity: string, entityId: string): Promise<ProductList> {
		const url = `${this.configService.getLoanService_V2_Url()}/product/${entity}/${entityId}`;
		return await this.httpClient.get<ProductList>(url).toPromise();
	}

	public async searchProducts(productSearchBody: InvestmentPreference[]): Promise<ProductList> {
		const url = `${this.configService.getLoanService_V2_Url()}/product/search`;
		return await this.httpClient.post<ProductList>(url, productSearchBody).toPromise();
	}

	public async getMasterProductsList(entity: string, entityId: string): Promise<MasterProduct> {
		const url = `${this.configService.getLoanService_V2_Url()}/product/master/${entity}/${entityId}`;
		return await this.httpClient.get<MasterProduct>(url).toPromise();
	}

	public async getRiskScore(lenderId: string): Promise<RiskScore> {
		const url = `${this.configService.getLoanService_V2_Url()}/product/lender/${lenderId}/risk-scores`;
		return await this.httpClient.get<RiskScore>(url).toPromise();
	}

}
